"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilitaryBranches = exports.MILITARY_BRANCH_COAST_GUARD = exports.MILITARY_BRANCH_MARINE_CORPS = exports.MILITARY_BRANCH_AIR_FORCE = exports.MILITARY_BRANCH_NAVY = exports.MILITARY_BRANCH_ARMY = void 0;
exports.MILITARY_BRANCH_ARMY = 'Army';
exports.MILITARY_BRANCH_NAVY = 'Navy';
exports.MILITARY_BRANCH_AIR_FORCE = 'Air Force';
exports.MILITARY_BRANCH_MARINE_CORPS = 'Marine Corps';
exports.MILITARY_BRANCH_COAST_GUARD = 'Coast Guard';
exports.MilitaryBranches = Object.freeze({
    Army: exports.MILITARY_BRANCH_ARMY,
    Navy: exports.MILITARY_BRANCH_NAVY,
    AirForce: exports.MILITARY_BRANCH_AIR_FORCE,
    MarineCorps: exports.MILITARY_BRANCH_MARINE_CORPS,
    CoastGuard: exports.MILITARY_BRANCH_COAST_GUARD,
});
//# sourceMappingURL=constants.js.map